//Modules
import { useState, useEffect, Fragment, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import * as urlSlug from 'url-slug'

//Components
import ListaUCs from './ListaUCs'

//Constants
import { escolas, campus, header, search, tipoCurso } from '../../../constants/cursos'

const { REACT_APP_GUIAECTS_EXTRA_CURRICULAR_MICROCREDENCIAIS } = process.env

function ListaIndividual({ cursos, tipo, lang }) {
    const [lista, setLista] = useState([])
    const [listaExtra, setListaExtra] = useState([])
    const [query, setQuery] = useState("")

    const location = useLocation()
    const searchRef = useRef(null)

    const { listaCursos, cursosIngles, extraCurr } = cursos

    const filteredCurso = lista.filter(item => {
        return (item.$.nome.toLowerCase().includes(query.toLowerCase()) || item.$.cod_curso.includes(query))
    })

    useEffect(() => {
        let listTipo = []
        let listTipoExtra = []
        
        // if (tipo[0] === "CL"){
        //     cursosLinguas && cursosLinguas.items.map((cl) => {
        //         listaCursos && listaCursos.ipb.curso.map((curso) => {                                         
        //             if (curso.$.cod_curso === cl?.acf.cod_curso) {
        //                 listTipo.push(curso)
        //             }
        //             return true
        //         })
        //         return true
        //     })
        // }else 
        if (tipo === "CI"){
            cursosIngles && cursosIngles.items.map((ci) => {
                listaCursos && listaCursos.ipb.curso.map((curso) => {                                         
                    if (curso.$.cod_curso === ci?.acf.cod_curso) {
                        listTipo.push(curso)
                    }
                    return true
                })
                return true
            })            
        }else if (tipo === "MC"){
            extraCurr && cursos.extraCurr.extraCurriculares.uc.map((ec) => {                                                       
                if (ec.$.tipo === REACT_APP_GUIAECTS_EXTRA_CURRICULAR_MICROCREDENCIAIS) {
                    listTipoExtra.push(ec.$)
                }
                return true                
            })            
        }else if (tipo === "MP"){
            listaCursos ? listTipo = listaCursos.ipb.curso.filter((curso) => {
                if (curso.$.cod_curso === "5075" || curso.$.cod_curso === "5076" || curso.$.cod_curso === "5078" || curso.$.cod_curso === "5082" ) {
                    return curso
                }else{
                    return false
                }
            }) :
            listTipo = []                  
        }else{
            listaCursos ? listTipo = listaCursos.ipb.curso.filter((curso) => {
                if (curso.$.tipo === tipo && curso.$.cod_curso !== "5075" && curso.$.cod_curso !== "5076" && curso.$.cod_curso !== "5078" && curso.$.cod_curso !== "9991" && curso.$.cod_curso !== "9501" && curso.$.cod_curso !== "5082" ) {
                    return curso
                }else{
                    return false
                }
            }) :
            listTipo = []                          
        }

        listTipo.sort((a,b) => 
            a.$.nome.localeCompare(b.$.nome, lang, {
                sensitivity: "base"
            })
        );

        setLista(listTipo)  
        setListaExtra(listTipoExtra)          
    }, [listaCursos, tipo, cursosIngles])

    useEffect(() => {
        const input = searchRef.current
        if (input && document.querySelector('.curso-search input[type="search"]') === input) {
            input.focus({ preventScroll: true })
        }
    }, [location.pathname, tipo])

  return (
    <div className='col-md-12'>
        <div className="position-relative">
            {tipo === "MC" ?
            <ListaUCs key={listaExtra.cod_curso} listaExtra={listaExtra} />
            :
            <>
                <div className='container-fluid curso-search'>
                    <label htmlFor="searchCourse" className="material-icons">search</label>
                    <input id='searchCourse' ref={searchRef} value={query} type='search' placeholder={`${search[lang]}`} onChange={(ev) => setQuery(ev.target.value)}></input>
                </div>
                <table className='curso-lista curso'>
                    <caption class="sr-only">Lista de cursos</caption>
                    <thead>
                        <tr>
                            <th>{header.codigo[lang]}</th>
                            {tipo === "CI" && <th>{header.tipo[lang]}</th>}
                            <th>{header.curso[lang]}</th>
                            <th>{header.escola[lang]}</th>
                            <th>{header.campus[lang]}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredCurso.map( (lt) => (
                        <tr key={lt.$.cod_curso}>
                            <td className='codInfo'>
                                {lt.$?.info && <span className="material-icons-outlined info" data-tooltip-id={`info_${lt.$.cod_curso}`}>info</span>}
                                <Tooltip id={`info_${lt.$.cod_curso}`} className='tooltipInfo' clickable place="top" variant="dark">
                                    <span className='tooltipInfo'>{lt.$?.info}</span>
                                </Tooltip>
                                {lt.$.cod_escola}
                                <span>{lt.$.cod_curso}</span>
                            </td>
                            {tipo === "CI" &&
                            <td className='tipoCurso'>
                                {tipoCurso[lt.$.tipo][lang]}
                            </td>
                            }                            
                            <td>
                                <Link to={location.pathname+"/"+urlSlug.convert(`${lt.$.nome} ${lt.$.cod_escola} ${lt.$.cod_curso}`)}>{lt.$.nome}</Link>
                                {(tipo[0] === "CI" && cursosIngles) ? 
                                cursosIngles.items.map((ci) => (
                                    <Fragment key={ci.ID}>
                                        {lt.$.cod_curso === ci?.acf.cod_curso && 
                                        ci.url !== "http://x" &&
                                        <a href={ci.url} target="_blank" rel="noreferrer"> (Informação Adicional)</a>}
                                    </Fragment>
                                )):null}
                                {/* {(tipo[0] === "CL" && cursosLinguas) ? 
                                cursosLinguas.items.map((cl) => (
                                    <Fragment key={cl.ID}>
                                        {lt.$.cod_curso === cl?.acf.cod_curso && 
                                        cl.url !== "http://x" &&
                                        <a href={cl.url} target="_blank" rel="noreferrer"> (Informação Adicional)</a>}
                                    </Fragment>
                                )):null} */}
                            </td>
                            <td>{escolas[lt.$.cod_escola][lang]}</td>
                            <td>{campus[lt.$.cod_escola][lang]}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </>}
        </div>
    </div>
  )
}

export default ListaIndividual